<template>
  <router-link
    :to="{ name: 'user.author.profile', params: {id: user.id} }"
    class="author"
  >
    <div class="author__infos">
      <picture
        class="author__avatar"
        :style="{ backgroundImage: `url(${user.avatar})` }"
      ></picture>
      <div>
        <h5 class="author__name text-truncate">{{ user.name }}</h5>
        <span class="author__cases">{{ user.teacher_cases }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    user: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .author {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    border-radius: 0.44444rem;
    border: 1px solid rgba(255, 255, 255, 0.10);
    background-color: $purple700;

    // &:hover { border-color: #ff8000 }

    &__infos {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      // background: lighten(#000, 95);
      padding: 10px;
    }

    &__name,
    &__cases {

    }

    &__name {
      font-weight: 700;
      margin-bottom: 5px;
    }

    &__avatar {
      flex: 0 0 auto;
      display: block;
      width: 55px;
      height: 55px;
      border-radius: 100%;
      margin-right: 10px;
      background-position: center center;
      background-size: cover;
    }

    &__cases {
      font-size: 0.9rem;
    }
  }
</style>